<template>
  <!-- 输入联想 -->
  <div
    ref="inputRef"
    class="input-associate"
    :style="{ top: `-${page.positionTop}px` }"
    v-if="page.inputThinkList.length > 0"
  >
    <div class="input-associate__header flex flex-between">
      <div class="input-associate__title flex flex-item-center">
        <img src="@/assets/images/think.png" alt="" />
        猜你想问
      </div>
      <img src="@/assets/images/change.png" alt="" @click="handleChange" />
    </div>
    <div
      v-for="(item, index) in thinkList"
      :key="index"
      class="input-associate__item line1"
      @click="handleInputThink(item)"
    >
      {{ item }}
    </div>
  </div>
</template>
<script setup>
import { debounce } from '@/utils'
import {
  reactive,
  getCurrentInstance,
  defineProps,
  watch,
  computed,
  onMounted,
  onBeforeUnmount,
  ref,
  defineEmits
} from 'vue'
const props = defineProps({
  msg: { type: String, default: '' },
  orgId: { type: String },
  showType: { type: Number, default: 1 },
  thinkConfig: { type: Object, default: () => {} }
})
const emit = defineEmits(['associate'])
const { proxy } = getCurrentInstance()
const page = reactive({
  thinkIndex: 0,
  inputThinkList: [],
  positionTop: 262
})
// 输入联想
const thinkList = computed(() => {
  let list = page.inputThinkList.slice(page.thinkIndex, page.thinkIndex + 5)
  return list || []
})
// 输入联想点击
const handleInputThink = (val) => {
  emit('associate', val)
  page.inputThinkList = []
}
// 输入联想切换
const handleChange = () => {
  if (page.thinkIndex + 5 === page.inputThinkList.length) {
    page.thinkIndex = 0
  } else {
    page.thinkIndex += 5
  }
}
// 监听输入
watch(
  () => props.msg,
  debounce(async (newVal) => {
    if (
      Object.keys(props.thinkConfig).length > 0 &&
      ((props.showType === 1 && props.thinkConfig.robotThink) ||
        (props.showType === 2 && props.thinkConfig.serviceThink)) &&
      newVal &&
      /\S/.test(newVal[0])
    ) {
      let id = localStorage.getItem('senderId')
      let query = { orgId: props.orgId, q: newVal[0], userId: id }
      let res = await proxy.$http.post('/textrobot/app/input/association', query)
      if (res.code === 0) {
        page.inputThinkList = res.data || []
      }
    }
  }),
  { immediate: true }
)
watch(
  () => thinkList.value,
  (newVal) => {
    if (newVal && newVal.length > 0) {
      let top = 63 + newVal.length * 33.5
      if (top < page.positionTop) {
        page.positionTop = top
      }
      top = null
    }
  },
  { immediate: true }
)
onMounted(() => {
  window.addEventListener('click', handleOutSideClick)
})
onBeforeUnmount(() => {
  window.removeEventListener('click', handleOutSideClick)
})
// 监听外部点击
const inputRef = ref(null)
const handleOutSideClick = (e) => {
  if (!inputRef.value?.contains(e.target)) {
    page.inputThinkList = []
  }
}
</script>
<style lang="less" scoped>
.input-associate {
  background: linear-gradient(274deg, #f6fbff 0%, #e8f5ff 100%);
  box-shadow: 0px 2px 8px 0px rgba(204, 213, 232, 0.1);
  border-radius: 8px;
  width: calc(100% - 24px);
  max-height: 250px;
  position: absolute;
  top: -262px;
  left: 12px;
  padding: 12px 20px;
  box-sizing: border-box;
  &__title {
    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    font-size: 14px;
    color: #3571f0;
  }
  &__header {
    margin-bottom: 8px;
    img {
      width: 16px;
      height: 16px;
    }
  }
  &__item {
    background: #ffffff;
    border-radius: 16px;
    font-size: 13px;
    color: #555555;
    line-height: 1.5;
    padding: 2px 20px;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
</style>
